import { VSwitch } from 'vuetify/lib/components/VSwitch';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VSwitch,{attrs:{"loading":_vm.loading,"input-value":_vm.user.emailVerified,"readonly":""},on:{"click":_vm.updateEmailVerification}})}
var staticRenderFns = []

export { render, staticRenderFns }